import { makeStyles } from '@material-ui/core';
import React, { useState } from 'react';

type TabProps = {
  tabsLength: number;
  selectedIndex: number;
  tabIndex: number;
  option: string;
  setSelectedIndex: Function;
};

const useStyles = makeStyles({
  option: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    textAlign: 'center',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    border: '1px solid white',
    color: 'white',
    transition: 'all 0.3s ease-in-out',
    cursor: 'pointer'
  }
});

const Tab: React.FC<TabProps> = ({
  tabsLength,
  selectedIndex,
  tabIndex,
  option,
  setSelectedIndex
}) => {
  const [hovering, setHovering] = useState(false);
  const classes = useStyles();

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      style={{
        position: 'relative',
        width: `calc(100% / ${tabsLength})`,
        opacity: hovering ? 0.6 : 1
      }}
    >
      <div></div>
      <div
        className={classes.option}
        style={{
          width: '100%',
          backgroundColor: selectedIndex === tabIndex ? '#0f80bd' : '#044358'
        }}
        onClick={() => setSelectedIndex(tabIndex)}
      >
        {option}
      </div>
      <div
        style={{
          backgroundColor: selectedIndex === tabIndex ? '#0f80bd' : '#044358'
        }}
      ></div>
    </div>
  );
};

export default Tab;
